<template>
  <div>
    <v-list two-line>
      <v-list-item
        v-for="community in communities"
        :key="community.id"
        @click="toCommunityProfile(community.id)"
      >
        <!-- <v-list-item-avatar>
          <v-icon color="accent" v-text="T"></v-icon>
        </v-list-item-avatar>-->

        <v-list-item-content>
          <v-list-item-title v-text="community.name"></v-list-item-title>
          <v-list-item-subtitle v-text="community.code"></v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
          <v-btn icon>
            <v-icon color="grey lighten-1">mdi-information</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </div>
</template>
<script>
import { communitiesRef } from "../../firebaseApp";

export default {
  data: () => ({
    communities: [],
    addAdmin: false
  }),
  components: {},
  methods: {
    deleteItem(key) {
      communitiesRef.child(key).remove();
    },
    toCommunityProfile(communityId) {
      this.$router.push("/community/" + communityId);
    }
    // editCommunity() {
    //     if(this.$refs.form.validate()) {
    //         this.community.dateAdded = Date.now();
    //         if(this.isUnique("code"))
    //           if(this.isUnique("name")) {
    //             communities.push(this.community).key
    //           }
    //           else {
    //               alert("A community has already been registered under the same name. Please use a different one")
    //           }
    //         else {
    //             this.generateCode();
    //             this.addCommunity();
    //         }
    //     }
    // },
  },
  mounted() {
    communitiesRef.on("value", snap => {
      let communities = [];
      snap.forEach(community => {
        let comm = {};
        comm = community.val();
        comm.id = community.key;
        communities.push(comm);
      });
      this.communities = communities;
    });
  }
};
</script>